import React from "react";
import { useQuickSightCostIntelligence  } from "@/hooks/useCostIntelligenceReports";

const QuickSightAwsCostIntelligenceDashboard = () => {
  const { embedUrl } = useQuickSightCostIntelligence();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsCostIntelligenceDashboard;
